<template v-html="svgElement">
  <span v-html="svgElement"></span>
</template>

<script>
import SVG from "svg-engine";
import generateQRCode from "@/util/qr-code";

export default {
  name: "SwissQRCode",
  props: {
    data: {
      type: Object,
      require: true,
    },
    width: {
      type: Number,
      default: 125,
    },
  },
  computed: {
    dataStr() {
      let qrString = "";

      //-- Swiss Payments Code
      qrString += "SPC";
      //-- Version
      qrString += "\n0200";
      //-- Coding Type UTF-8
      qrString += "\n1";
      //-- IBAN
      qrString += "\n" + this.data.creditor.iban ?? "\n";
      //-- Creditor

      // Address Type
      qrString += "\nS";
      qrString += "\n" + this.data.creditor.name; // Name
      qrString += "\n" + this.data.creditor.addresse; // Address
      qrString += "\n" + this.data.creditor.hausnr; // House number
      qrString += "\n" + this.data.creditor.plz; // Zip
      qrString += "\n" + this.data.creditor.ort; // City
      qrString += "\n" + this.data.creditor.country; // Country

      //-- 7 x empty
      qrString += "\n"; // 1
      qrString += "\n"; // 2
      qrString += "\n"; // 3
      qrString += "\n"; // 4
      qrString += "\n"; // 5
      qrString += "\n"; // 6
      qrString += "\n"; // 7

      //-- Amount
      if (this.data.amount !== undefined) {
        qrString += "\n" + this.data.amount.toFixed(2);
      } else {
        qrString += "\n";
      }

      //-- Currency
      qrString += "\n" + this.data.currency;

      //-- Debtor
      if (this.data.debtor !== undefined) {
        if (this.data.debtor.buildingNumber !== undefined) {
          qrString += "\nS"; // Address type
          qrString += "\n" + this.data.debtor.name; // Name
          qrString += "\n" + this.data.debtor.address; // Address
          qrString += "\n" + this.data.debtor.buildingNumber; // House number
          qrString += "\n" + this.data.debtor.zip; // Zip
          qrString += "\n" + this.data.debtor.city; // City
        } else {
          qrString += "\nK"; // Address type
          qrString += "\n" + this.data.debtor.name; // Name
          qrString += "\n" + this.data.debtor.address; // Address
          if ((this.data.debtor.zip + " " + this.data.debtor.city).length > 70)
            throw new Error(
              "Debtor zip plus city must be a maximum of 70 characters."
            );
          qrString += "\n" + this.data.debtor.zip + " " + this.data.debtor.city; // Zip + city
          qrString += "\n"; // Empty field zip
          qrString += "\n"; // Empty field city
        }
        qrString += "\n" + this.data.debtor.country; // Country
      } else {
        qrString += "\n"; // Empty field type
        qrString += "\n"; // Empty field name
        qrString += "\n"; // Empty field address
        qrString += "\n"; // Empty field house number
        qrString += "\n"; // Empty field zip
        qrString += "\n"; // Empty field city
        qrString += "\n"; // Empty field country
      }

      //-- Reference type
      qrString +=
        this.data.reference !== undefined && this.data.reference !== null
          ? "\nQRR"
          : "\nNON";

      //-- Reference
      if (this.data.reference !== undefined && this.data.reference !== null) {
        qrString +=
          "\n" + this.data.reference //+ this.getPruefziffer(this.data.reference); Prüfziffer ist bereits an der API-Response enthalten
      } else {
        qrString += "\n";
      }

      //-- Unstructured message
      if (this.data.message !== undefined) {
        qrString += "\n" + this.data.message;
      } else {
        qrString += "\n";
      }

      //-- End Payment Data
      qrString += "\n" + "EPD";

      //-- Additional information
      if (this.data.additionalInformation !== undefined) {
        qrString += "\n" + this.data.additionalInformation;
      } else {
        qrString += "\n";
      }

      //-- AV1
      if (this.data.av1 !== undefined) {
        qrString += "\n" + this.data.av1;
      }

      if (this.data.av2 !== undefined) {
        qrString += "\n" + this.data.av2;
      }
      return qrString;
    },
    svgElement() {
      const qrcodeSVG = new SVG();
      //svg.width("50px");
      //svg.height("50px");
      //qrcodeSVG.viewBox("100%", "100%");
      qrcodeSVG.width(this.width);
      qrcodeSVG.height(this.width);

      const qrcode = generateQRCode(this.dataStr, this.width);

      const f = this.width / 46;

      qrcodeSVG.addPath(qrcode).fill("black");
      //-- Add background
      qrcodeSVG.addRect(19 * f, 19 * f, 8 * f, 8 * f).fill("white");
      qrcodeSVG.addRect(19.5 * f, 19.5 * f, 7 * f, 7 * f).fill("black");
      //-- Add swiss cross
      qrcodeSVG
        .addRect(22.415 * f, 21.055 * f, 1.17 * f, 3.89 * f)
        .fill("white");
      qrcodeSVG
        .addRect(21.055 * f, 22.415 * f, 3.89 * f, 1.17 * f)
        .fill("white");

      return qrcodeSVG.outerHTML;
    },
  },
  methods: {
    getPruefziffer(referenz) {
      var tabelle = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];
      var uebertrag = 0;

      for (let i = 0; i < referenz.length; i++) {
        uebertrag =
          tabelle[
            (uebertrag + referenz.charAt(i).charCodeAt() - "0".charCodeAt()) %
              10
          ];
      }

      return ((10 - uebertrag) % 10).toString();
    },
  },
};
</script>
